/**
 * A global namespace for `gesturechange` event.
 */
const gesturechangeEvent = "gesturechange";
export default gesturechangeEvent;
